const sideMenuList1 = [
  {
    id: 1,
    title: '대쉬보드',
    icon: '/static/sidemenu/dashboard.png',
    selectedIcon: '/static/sidemenu/dashboard-selected.png',
    path: '/dashboard',
    children: [
      {
        id: 2,
        title: 'Job Management',
        path: '/dashboard/job-management',
      },
      {
        id: 3,
        title: 'CRM',
        path: '/dashboard/crm',
      },
      {
        id: 4,
        title: 'Sales',
        path: '/dashboard/sales',
      },
      {
        id: 5,
        title: 'Sub Child',
        path: '/dashboard/sub-child',
        subChildren: [
          {
            id: 6,
            title: 'Sub Child V1',
            path: '/dashboard/sub-child-v1',
          },
          {
            id: 7,
            title: 'Sub Child V2',
            path: '/dashboard/sub-child-v2',
          },
          {
            id: 8,
            title: 'Sub Child V3',
            path: '/dashboard/sub-child-v3',
          },
        ],
      },
      {
        id: 9,
        title: 'Sales V2',
        path: '/dashboard/sales-v2',
      },
      {
        id: 10,
        title: 'SaaS',
        path: '/dashboard/saas',
      },
    ],
  },
  {
    id: 11,
    title: '회원정보',
    icon: '/static/sidemenu/user.png',
    selectedIcon: '/static/sidemenu/user-selected.png',
    path: '/dashboard/add-user',
    children: [
      {
        id: 12,
        title: 'User List',
        path: '/dashboard/user-list',
      },
      {
        id: 13,
        title: '회원목록',
        path: '/dashboard/data-table-v2',
      },
      {
        id: 14,
        title: '회원 정보 수정',
        path: '/dashboard/myinfoedit',
      },
      {
        id: 15,
        title: '계정 정보',
        path: '/dashboard/accountinfo',
      },
    ],
  },
  {
    id: 16,
    title: '모바일 명함',
    icon: '/static/sidemenu/namecard.png',
    selectedIcon: '/static/sidemenu/namecard-selected.png',
    path: '/naver/namecard',
    children: [
      {
        id: 17,
        title: '활용통계',
        path: '/dashboard/statistics',
      },
      {
        id: 18,
        title: '프로필 관리',
        path: '/dashboard/namecardprofile',
      },
    ],
  },
  {
    id: 19,
    title: '기업DB 목록',
    icon: '/static/sidemenu/folder.png',
    selectedIcon: '/static/sidemenu/folder-selected.png',
    path: '/dashboard/Excel',
    children: [
      {
        id: 20,
        title: '기업DB 목록2',
        path: '/dashboard/Excel2',
      },
    ],
  },
  {
    id: 21,
    title: '인바운드 설문',
    icon: '/static/sidemenu/paper.png',
    selectedIcon: '/static/sidemenu/paper-selected.png',
    path: '/dashboard/progress',
    children: [
      {
        id: 22,
        title: '인바운드 설문2',
        path: '/dashboard/progress2',
      },
    ],
  },
  {
    id: 23,
    title: '네이버',
    icon: '/static/sidemenu/briefcase.png',
    selectedIcon: '/static/sidemenu/briefcase-selected.png',
    path: '/naver/naver',
  },
  {
    id: 24,
    title: '기업마당',
    icon: '/static/sidemenu/speaker.png',
    selectedIcon: '/static/sidemenu/speaker-selected.png',
    path: '/naver/naverlist',
  },
  {
    id: 25,
    title: '달력',
    icon: '/static/sidemenu/calendar.png',
    selectedIcon: '/static/sidemenu/calendar-selected.png',
    path: '/dashboard/calendar',
  },
  // {
  //   id: 26,
  //   title: "커뮤니티",
  //   icon: "/static/sidemenu/chat.png",
  //   selectedIcon: "/static/sidemenu/chat-selected.png",
  //   path: "/dashboard/forumlist",
  // },
  {
    id: 27,
    title: '강의 메인페이지',
    icon: '/static/sidemenu/graduation.png',
    selectedIcon: '/static/sidemenu/graduation-selected.png',
    path: '/naver/coursemain',
    children: [
      {
        id: 28,
        title: '강의 상세페이지',
        path: '/naver/course',
      },
    ],
  },
  {
    id: 29,
    title: '정박사',
    icon: '/static/sidemenu/medal.png',
    selectedIcon: '/static/sidemenu/medal-selected.png',
    path: '/naver/jungbaksa',
  },
  {
    id: 30,
    title: '에디터',
    icon: '/static/sidemenu/pen.png',
    selectedIcon: '/static/sidemenu/pen-selected.png',
    path: '/dashboard/texteditor',
    children: [
      {
        id: 31,
        title: '에디터2',
        path: '/naver/texteditor2',
      },
    ],
  },
  {
    id: 32,
    title: '뤼튼',
    icon: '/static/sidemenu/lightbulb.png',
    selectedIcon: '/static/sidemenu/lightbulb-selected.png',
    path: '/naver/wrtn',
  },
  {
    id: 33,
    title: 'DB 가공기',
    icon: '/static/sidemenu/triangle.png',
    selectedIcon: '/static/sidemenu/triangle-selected.png',
    path: '/dashboard/dbprocess',
    children: [
      {
        id: 34,
        title: '기업 리포트 생성기',
        path: '/naver/report-creator',
      },
    ],
  },
  {
    id: 35,
    title: 'API 관리',
    icon: '/static/sidemenu/shapes.png',
    selectedIcon: '/static/sidemenu/shapes-selected.png',
    path: '/dashboard/apimanagement',
  },
  {
    id: 36,
    title: '결제 회원 관리',
    icon: '/static/sidemenu/shapes.png',
    selectedIcon: '/static/sidemenu/shapes-selected.png',
    path: '/dashboard/user-payment-management',
  },
  {
    id: 37,
    title: '팝업광고',
    icon: '/static/sidemenu/video.png',
    selectedIcon: '/static/sidemenu/video-selected.png',
    path: '/dashboard/popupad',
  },
  {
    id: 38,
    title: '회사소개',
    icon: '/static/sidemenu/graduation.png',
    selectedIcon: '/static/sidemenu/graduation-selected.png',
    path: '/naver/landing-main',
    children: [
      {
        id: 39,
        title: '회사소개1',
        path: '/naver/landing2',
      },
      {
        id: 40,
        title: '회사소개2',
        path: '/naver/landing3',
      },
      {
        id: 41,
        title: '회사소개3',
        path: '/naver/landing4',
      },
      {
        id: 42,
        title: '회사소개4',
        path: '/naver/landing5',
      },
    ],
  },
  {
    id: 43,
    title: '벤처인증',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/survey1',
    children: [
      {
        id: 44,
        title: '벤처인증2',
        path: '/naver/survey2',
      },
      {
        id: 45,
        title: '벤처인증3',
        path: '/naver/survey3',
      },
    ],
  },
  {
    id: 46,
    title: 'divider',
  },
  {
    id: 47,
    title: '지원금 페이지',
    icon: '/static/sidemenu/coin.png',
    selectedIcon: '/static/sidemenu/coin-selected.png',
    path: '/naver/jiwongummain',
    children: [
      {
        id: 48,
        title: '지원금 페이지2',
        path: '/naver/jiwongummain2',
      },
    ],
  },
  {
    id: 49,
    title: '정책자금 상담',
    icon: '/static/sidemenu/stamp.png',
    selectedIcon: '/static/sidemenu/stamp-selected.png',
    path: '/naver/jiwonguminquiry',
  },
  {
    id: 50,
    title: '대표님 컨텐츠',
    icon: '/static/sidemenu/contents.png',
    selectedIcon: '/static/sidemenu/contents-selected.png',
    path: '/naver/jiwongumcontents',
  },
  {
    id: 51,
    title: '정책자금 찾기',
    icon: '/static/sidemenu/find.png',
    selectedIcon: '/static/sidemenu/find-selected.png',
    path: '/naver/jiwongumfind',
    children: [
      {
        id: 52,
        title: '대출한도 계산하기 1',
        path: '/naver/jiwongumcalculate1',
      },
      {
        id: 53,
        title: '대출한도 계산하기 2',
        path: '/naver/jiwongumcalculate2',
      },
      {
        id: 54,
        title: '대출한도 계산하기 3',
        path: '/naver/jiwongumcalculate3',
      },
      {
        id: 55,
        title: '대출한도 계산하기 4',
        path: '/naver/jiwongumcalculate4',
      },
      {
        id: 56,
        title: '대출한도 계산하기 5',
        path: '/naver/jiwongumcalculate5',
      },
      {
        id: 57,
        title: '대출한도 계산하기 6',
        path: '/naver/jiwongumcalculate6',
      },
      {
        id: 58,
        title: '대출한도 계산하기 7',
        path: '/naver/jiwongumcalculate7',
      },
    ],
  },
  {
    id: 59,
    title: '보험사 리스트',
    icon: '/static/sidemenu/calculator.png',
    selectedIcon: '/static/sidemenu/calculator-selected.png',
    path: '/dashboard/companylist',
  },
  {
    id: 60,
    title: '업무관리',
    icon: '/static/sidemenu/calendar.png',
    selectedIcon: '/static/sidemenu/calendar-selected.png',
    path: '/naver/workschedule',
  },
  {
    id: 61,
    title: 'divider',
  },
  {
    id: 62,
    title: '비디오 에디터',
    icon: '/static/sidemenu/video.png',
    selectedIcon: '/static/sidemenu/video-selected.png',
    path: '/dashboard/videoeditor',
  },
  {
    id: 63,
    title: '메뉴 에디터',
    icon: '/static/sidemenu/menu.png',
    selectedIcon: '/static/sidemenu/menu-selected.png',
    path: '/dashboard/menueditor',
  },
  {
    id: 64,
    title: '배너 에디터',
    icon: '/static/sidemenu/layer.png',
    selectedIcon: '/static/sidemenu/layer-selected.png',
    path: '/dashboard/bannereditor',
  },
  {
    id: 65,
    title: 'divider',
  },
  {
    id: 66,
    title: '그래프',
    icon: '/static/sidemenu/graph.png',
    selectedIcon: '/static/sidemenu/graph-selected.png',
    path: '/naver/jiwongumcontents',
  },
  {
    id: 67,
    title: '직원',
    icon: '/static/sidemenu/worker.png',
    selectedIcon: '/static/sidemenu/worker-selected.png',
    path: '/naver/jiwongumcontents',
  },
  {
    id: 68,
    title: '쇼핑몰',
    icon: '/static/sidemenu/find.png',
    selectedIcon: '/static/sidemenu/find-selected.png',
    path: '/naver/shoppinglist',
  },
  {
    id: 69,
    title: '예약 서비스',
    icon: '/static/sidemenu/bell.png',
    selectedIcon: '/static/sidemenu/bell-selected.png',
    path: '/naver/bookinglist',
  },
  {
    id: 70,
    title: '컨텐츠 로그인 유도',
    icon: '/static/sidemenu/bell.png',
    selectedIcon: '/static/sidemenu/bell-selected.png',
    path: '/dashboard/blur-post',
  },
  {
    id: 71,
    title: '보험 채팅',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/insurance-chat',
  },
  {
    id: 72,
    title: 'AI 지원사업 요약',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/main-ai',
  },
];

const sideMenuList2 = [
  {
    id: 1,
    title: '커뮤니티 메인',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/community',
  },
  {
    id: 2,
    title: '커뮤니티 카테고리',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/community/category',
  },
  {
    id: 3,
    title: '커뮤니티 상세',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/community/detail',
  },
  {
    id: 4,
    title: '상대방 프로필',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/community/profile/other',
  },
  {
    id: 5,
    title: '커뮤니티 글쓰기',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/community/editor',
  },
  {
    id: 6,
    title: '커뮤니티 리스트',
    icon: '/static/sidemenu/chat.png',
    selectedIcon: '/static/sidemenu/chat-selected.png',
    path: '/naver/forumlist',
    children: [
      {
        id: 7,
        title: '암',
        path: '/naver/forumlist?tab=1',
      },
      {
        id: 8,
        title: '뇌/심장',
        path: '/naver/forumlist?tab=2',
      },
      {
        id: 9,
        title: '입원/수술비',
        path: '/naver/forumlist?tab=3',
      },
      {
        id: 10,
        title: '후유장해',
        path: '/naver/forumlist?tab=4',
      },
      {
        id: 11,
        title: '치매/간병/재가',
        path: '/naver/forumlist?tab=5',
      },
      {
        id: 12,
        title: '운전자/상해',
        path: '/naver/forumlist?tab=6',
      },
    ],
  },
];

export { sideMenuList1, sideMenuList2 };
